var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseGridLayout',{attrs:{"id":_vm.anchorName,"size":"small"}},[_c('Statement',{attrs:{"author":_vm.author,"content":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }